import type { Chart, JsonValue } from "./chart";

export interface ReportOptions {
  title: string;
  run: (chart: Chart) => string;
}

export interface ReportData {
  [key: string]: JsonValue;
}

export class Report {
  data: ReportData;
  title: string;
  run: (chart: Chart) => string;

  constructor(options: ReportOptions) {
    this.data = {} as ReportData;
    this.title = options.title;
    this.run = options.run.bind(this);
  }

  getData(): ReportData | undefined {
    if (Object.keys(this.data).length === 0) {
      return;
    }
    return this.data;
  }
}
